<script>
    import DataTable from "../../components/data-table.svelte";

    let users = [
        {
            id: 1,
            firstName: "John",
            middleName: "",
            lastName: "Smith",
            mark: "/",
            session: 'PM',
            date: "20 Dec 2020",
            reason: "invalid mark"
        },
        {
            id: 1,
            firstName: "John",
            middleName: "",
            lastName: "Smith",
            mark: "/",
            session: 'PM',
            date: "20 Dec 2020",
            reason: "invalid mark"
        },
        {
            id: 1,
            firstName: "John",
            middleName: "",
            lastName: "Smith",
            mark: "/",
            session: 'PM',
            date: "20 Dec 2020",
            reason: "invalid mark"
        },
        {
            id: 1,
            firstName: "John",
            middleName: "",
            lastName: "Smith",
            mark: "/",
            session: 'PM',
            date: "20 Dec 2020",
            reason: "invalid mark"
        }
    ];

    
    let columnDefs = [{ type: 'date-euro', targets: [2] }];
</script>

<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#errors">Errors</a>
    </li>
</ul>

<br />

<div class="tab-content">

    <div class="tab-pane active" id="errors">
        <div class="card">

            <div class="card-body with-table">
                <DataTable {columnDefs} DataLength={users.length} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">
                                First Name
                            </th>
                            <th>Last Name</th>
                            <th>Date</th>
                            <th>Session</th>
                            <th>Mark</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                            <tr>
                                <td>{user.firstName}</td>
                                <td>{user.lastName}</td>
                                <td>{user.date}</td>
                                <td>{user.session}</td>
                                <td>{user.mark}</td>
                                <td>{user.reason}</td>
                            </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>
    </div>
</div>